
import { defineComponent } from "vue";
// @ts-expect-error error
import mallorcaLogo from "@/assets/mallorca-logo-w&b.png";
import FilminLogo from "@/components/FilminLogo.vue";

export default defineComponent({
  components: {
    FilminLogo,
  },
  props: {
    withoutIcon: { type: Boolean },
    height: { type: String },
    isSmall: { type: Boolean },
  },
  setup() {
    return {
      mallorcaLogo,
    };
  },
});
